export const DeviceManagementIcons = ({ type, size = 20, color }) => {
  const icons = {
    secret: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M4.16699 10.8334C4.16699 10.3914 4.34259 9.96746 4.65515 9.6549C4.96771 9.34234 5.39163 9.16675 5.83366 9.16675H14.167C14.609 9.16675 15.0329 9.34234 15.3455 9.6549C15.6581 9.96746 15.8337 10.3914 15.8337 10.8334V15.8334C15.8337 16.2754 15.6581 16.6994 15.3455 17.0119C15.0329 17.3245 14.609 17.5001 14.167 17.5001H5.83366C5.39163 17.5001 4.96771 17.3245 4.65515 17.0119C4.34259 16.6994 4.16699 16.2754 4.16699 15.8334V10.8334Z"
          stroke="url(#paint0_linear_5577_1160)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66699 9.16667V5.83333C6.66699 4.94928 7.01818 4.10143 7.6433 3.47631C8.26842 2.85119 9.11627 2.5 10.0003 2.5C10.8844 2.5 11.7322 2.85119 12.3573 3.47631C12.9825 4.10143 13.3337 4.94928 13.3337 5.83333V9.16667"
          stroke="url(#paint1_linear_5577_1160)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 13.3333H12.5083"
          stroke="url(#paint2_linear_5577_1160)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0088 13.3333H10.0171"
          stroke="url(#paint3_linear_5577_1160)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5166 13.3333H7.52493"
          stroke="url(#paint4_linear_5577_1160)"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_5577_1160"
            x1="3.41195"
            y1="16.1213"
            x2="17.0031"
            y2="16.4718"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <linearGradient
            id="paint1_linear_5577_1160"
            x1="6.23554"
            y1="8.06367"
            x2="14.0044"
            y2="8.20678"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <linearGradient
            id="paint2_linear_5577_1160"
            x1="12.4995"
            y1="14.1678"
            x2="12.5092"
            y2="14.1678"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <linearGradient
            id="paint3_linear_5577_1160"
            x1="10.0082"
            y1="14.1678"
            x2="10.018"
            y2="14.1678"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <linearGradient
            id="paint4_linear_5577_1160"
            x1="7.51606"
            y1="14.1678"
            x2="7.52578"
            y2="14.1678"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={color} />
            <stop offset="1" stopColor={color} />
          </linearGradient>
        </defs>
      </svg>
    ),
    token: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 5.83325H10.0083"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 5.83325H12.5083"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 5.83325H7.50833"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.16699 4.16667C4.16699 3.72464 4.34259 3.30072 4.65515 2.98816C4.96771 2.67559 5.39163 2.5 5.83366 2.5H14.167C14.609 2.5 15.0329 2.67559 15.3455 2.98816C15.6581 3.30072 15.8337 3.72464 15.8337 4.16667V15.8333C15.8337 16.2754 15.6581 16.6993 15.3455 17.0118C15.0329 17.3244 14.609 17.5 14.167 17.5H5.83366C5.39163 17.5 4.96771 17.3244 4.65515 17.0118C4.34259 16.6993 4.16699 16.2754 4.16699 15.8333V4.16667Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 12.5H12.5"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.16699 9.16675H15.8337"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    certificate: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 12.5C10 13.163 10.2634 13.7989 10.7322 14.2678C11.2011 14.7366 11.837 15 12.5 15C13.163 15 13.7989 14.7366 14.2678 14.2678C14.7366 13.7989 15 13.163 15 12.5C15 11.837 14.7366 11.2011 14.2678 10.7322C13.7989 10.2634 13.163 10 12.5 10C11.837 10 11.2011 10.2634 10.7322 10.7322C10.2634 11.2011 10 11.837 10 12.5Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.833 14.5833V18.3333L12.4997 17.0833L14.1663 18.3333V14.5833"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.33333 15.8334H4.16667C3.72464 15.8334 3.30072 15.6578 2.98816 15.3453C2.67559 15.0327 2.5 14.6088 2.5 14.1667V5.83341C2.5 4.91675 3.25 4.16675 4.16667 4.16675H15.8333C16.2754 4.16675 16.6993 4.34234 17.0118 4.6549C17.3244 4.96746 17.5 5.39139 17.5 5.83341V14.1667C17.4997 14.459 17.4225 14.7461 17.2763 14.9991C17.13 15.2522 16.9198 15.4623 16.6667 15.6084"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 7.5H15"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 10H7.5"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 12.5H6.66667"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    keys: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M13.7958 3.20258L16.7975 6.20425C17.0202 6.42688 17.1968 6.6912 17.3173 6.9821C17.4378 7.273 17.4998 7.58479 17.4998 7.89967C17.4998 8.21454 17.4378 8.52633 17.3173 8.81723C17.1968 9.10814 17.0202 9.37245 16.7975 9.59508L14.595 11.7976C14.3724 12.0203 14.1081 12.1969 13.8172 12.3174C13.5262 12.4379 13.2145 12.4999 12.8996 12.4999C12.5847 12.4999 12.2729 12.4379 11.982 12.3174C11.6911 12.1969 11.4268 12.0203 11.2042 11.7976L10.9533 11.5468L5.48833 17.0118C5.21143 17.2886 4.8459 17.4591 4.45583 17.4934L4.31 17.5001H3.33333C3.12922 17.5001 2.93222 17.4251 2.77969 17.2895C2.62716 17.1539 2.52971 16.967 2.50583 16.7643L2.5 16.6668V15.6901C2.5001 15.2988 2.63786 14.92 2.88917 14.6201L2.98833 14.5118L3.33333 14.1668H5V12.5001H6.66667V10.8334L8.45333 9.04675L8.2025 8.79592C7.97983 8.57328 7.8032 8.30897 7.68269 8.01807C7.56219 7.72717 7.50016 7.41538 7.50016 7.1005C7.50016 6.78563 7.56219 6.47383 7.68269 6.18293C7.8032 5.89203 7.97983 5.62772 8.2025 5.40508L10.405 3.20258C10.6276 2.97992 10.8919 2.80329 11.1828 2.68278C11.4738 2.56227 11.7855 2.50024 12.1004 2.50024C12.4153 2.50024 12.7271 2.56227 13.018 2.68278C13.3089 2.80329 13.5732 2.97992 13.7958 3.20258Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 7.5H12.5083"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    keyValue: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M8.5 8.5L13.75 13.75"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.1221 13.8125L17.0221 14.7116C17.3285 15.0181 17.5005 15.4336 17.5004 15.8669C17.5004 16.3002 17.3282 16.7157 17.0217 17.022C16.7153 17.3284 16.2997 17.5004 15.8664 17.5003C15.4331 17.5003 15.0176 17.3281 14.7113 17.0216L13.8113 16.1225C13.505 15.816 13.3329 15.4004 13.333 14.9672C13.3331 14.5339 13.5053 14.1184 13.8117 13.812C14.1182 13.5057 14.5337 13.3337 14.967 13.3337C15.4003 13.3338 15.8158 13.506 16.1221 13.8125Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 5.83333L5.04167 8.45833C5.49841 8.89332 6.10711 9.13251 6.7378 9.12482C7.36849 9.11713 7.97118 8.86317 8.41717 8.41717C8.86317 7.97118 9.11713 7.36849 9.12482 6.7378C9.13251 6.10711 8.89332 5.49841 8.45833 5.04167L5.83333 2.5"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    password: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 8.33325V11.6666"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.33301 10.8334L11.6663 9.16675"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.33301 9.16675L11.6663 10.8334"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.16699 8.33325V11.6666"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 10.8334L5.83333 9.16675"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 9.16675L5.83333 10.8334"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.833 8.33325V11.6666"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.167 10.8334L17.5003 9.16675"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.167 9.16675L17.5003 10.8334"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  };

  return icons[type];
};

export default DeviceManagementIcons;
